import { render, staticRenderFns } from "./InvestorDashboardComponent.vue?vue&type=template&id=3fc665f9&scoped=true"
import script from "./InvestorDashboardComponent.vue?vue&type=script&lang=js"
export * from "./InvestorDashboardComponent.vue?vue&type=script&lang=js"
import style0 from "./InvestorDashboardComponent.vue?vue&type=style&index=0&id=3fc665f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc665f9",
  null
  
)

export default component.exports